import debounce from 'lodash/debounce'

const DEBOUNCE_DELAY = 10

const syncHeaderCellsSizes = (originalHeader: HTMLElement, stickyHeader: Element) => {
  const originalCells = originalHeader.querySelectorAll('th, td')
  const stickyCells = stickyHeader.querySelectorAll('th, td')

  for (let i = 0; i < originalCells.length; i++) {
    const originalCell = originalCells[i]
    const stickyCell = stickyCells[i] as HTMLElement
    if (stickyCell) {
      const computedStyle = window.getComputedStyle(originalCell)
      const width = computedStyle.width

      stickyCell.style.width = width
      stickyCell.style.minWidth = width
      stickyCell.style.maxWidth = width
    }
  }
}

const debouncedSyncHeaderCellsSizes = debounce(syncHeaderCellsSizes, DEBOUNCE_DELAY)

export const syncTableColumnWidths = (tableContainer: HTMLElement) => {
  const originalHeader = tableContainer.querySelector('thead')
  const stickyHeader = document.querySelector('[data-sticky-header] thead')

  if (originalHeader && stickyHeader) {
    debouncedSyncHeaderCellsSizes(originalHeader, stickyHeader)
  }
}
